import React, { Children } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { UnlockIcon, ZapIcon, UserCheckIcon, XCircleIcon } from 'lucide-react';
export function DownsellPage() {
  const navigate = useNavigate();
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  };
  const bullets = [{
    icon: <UnlockIcon className="w-6 h-6 text-brand-gold" data-id="element-230" />,
    text: 'Acceso completo'
  }, {
    icon: <ZapIcon className="w-6 h-6 text-brand-gold" data-id="element-231" />,
    text: 'Resultados en segundos'
  }, {
    icon: <UserCheckIcon className="w-6 h-6 text-brand-gold" data-id="element-232" />,
    text: 'Sin necesidad de experiencia'
  }, {
    icon: <XCircleIcon className="w-6 h-6 text-brand-gold" data-id="element-233" />,
    text: 'Cancelación automática'
  }];
  return <main className="min-h-screen w-full bg-brand-bg text-brand-text font-sans selection:bg-brand-gold/30 selection:text-brand-gold flex items-center justify-center p-4 relative overflow-hidden" data-id="element-234">
      {/* Background radial gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(212,168,67,0.1)_0%,rgba(10,14,23,1)_70%)] pointer-events-none" data-id="element-235" />

      <motion.div variants={containerVariants} initial="hidden" animate="visible" className="relative z-10 w-full max-w-2xl mx-auto flex flex-col items-center text-center space-y-10" data-id="element-236">
        {/* Header */}
        <motion.div variants={itemVariants} className="space-y-4" data-id="element-237">
          <p className="text-brand-gold/70 font-bold tracking-widest uppercase text-sm md:text-base" data-id="element-238">
            ⏳ Segunda oportunidad
          </p>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brand-gold leading-tight tracking-tight drop-shadow-lg" data-id="element-239">
            No te vayas… pruébalo primero
          </h1>
          <h2 className="text-xl md:text-2xl text-brand-text font-medium leading-relaxed" data-id="element-240">
            Acceso completo por 5 días — sin compromiso
          </h2>
        </motion.div>

        {/* Card */}
        <motion.div variants={itemVariants} className="bg-brand-card/80 backdrop-blur-sm border border-brand-gold/20 rounded-2xl p-6 md:p-8 w-full shadow-[0_0_40px_rgba(212,168,67,0.1)]" data-id="element-241">
          <p className="text-lg text-brand-muted mb-8 text-left" data-id="element-242">
            Si todavía no estás seguro, prueba la herramienta y comprueba cómo
            funciona para ti. Sin riesgo, sin compromiso.
          </p>

          {/* Value bullets */}
          <ul className="space-y-4 text-left mb-8" data-id="element-243">
            {bullets.map((bullet, idx) => <li key={idx} className="flex items-center gap-4" data-id="element-244">
                <div className="bg-brand-gold/10 p-2 rounded-lg border border-brand-gold/20" data-id="element-245">
                  {bullet.icon}
                </div>
                <span className="text-lg md:text-xl font-medium text-brand-text" data-id="element-246">
                  {bullet.text}
                </span>
              </li>)}
          </ul>

          {/* Offer block */}
          <div className="bg-brand-bg/50 rounded-xl p-6 border border-brand-gold/10 mb-8 relative overflow-hidden" data-id="element-247">
            <div className="absolute -top-3 -right-3 bg-brand-green text-brand-bg text-xs font-bold px-3 py-1 rounded-md uppercase tracking-wide rotate-12 shadow-lg" data-id="element-248">
              -81%
            </div>
            <p className="text-brand-muted text-sm mb-2" data-id="element-249">
              Precio normal: <span className="line-through" data-id="element-250">$27</span>
            </p>
            <p className="text-xl md:text-2xl font-bold text-brand-text" data-id="element-251">
              Prueba BetIQ por solo <span className="text-brand-gold" data-id="element-252">$5</span>{' '}
              <span className="text-brand-muted text-lg font-normal" data-id="element-253">
                (5 días)
              </span>
            </p>
            <p className="text-brand-muted text-sm mt-2" data-id="element-254">
              Se cancela automáticamente. Sin cargos ocultos.
            </p>
          </div>

          {/* CTAs */}
          <div className="flex flex-col items-center space-y-4" data-id="element-255">
            <button onClick={() => navigate('/betiq-access')} className="relative group overflow-hidden rounded-md font-heading font-bold text-lg md:text-xl bg-brand-gold text-brand-bg px-8 py-5 w-full transition-all duration-300 hover:scale-[1.02] hover:shadow-[0_0_30px_rgba(212,168,67,0.4)]" data-id="element-256">
              <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-257">
                Probar ahora
              </span>
              <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" data-id="element-258" />
            </button>
            <p className="text-brand-muted text-xs tracking-wide" data-id="element-259">
              Acceso inmediato • Cancelación automática • Sin riesgo
            </p>

            <button onClick={() => navigate('/thank-you')} className="text-brand-faint hover:text-brand-muted text-sm underline underline-offset-4 transition-colors duration-200 mt-4" data-id="element-260">
              No, continuar sin acceso
            </button>
          </div>
        </motion.div>
      </motion.div>
    </main>;
}